import { StandardReport } from '../../../models';
import { SideNavCategoryTypeName } from '../../../components/side-nav';
import { FindReportSideNavItem } from '..';

const isMatchSubCategory = (
  standardReportId: number,
  cat: FindReportSideNavItem,
): boolean => {
  switch (cat.typeName) {
    // Only search for StandardReport, ignore other categoryTypes
    case SideNavCategoryTypeName.StandardReport:
      return (cat.tag as StandardReport).reportId === standardReportId;
  }

  return false;
};

const searchSubCategory = (
  cats: FindReportSideNavItem[],
  standardReportId: number,
): FindReportSideNavItem => {
  for (const cat of cats) {
    const hasItems = !!cat.items;
    if (!hasItems && isMatchSubCategory(standardReportId, cat)) {
      return cat;
    }
    if (hasItems) {
      const subCat = searchSubCategory(
        cat.items as FindReportSideNavItem[],
        standardReportId,
      );
      if (subCat) return subCat;
    }
  }
  return null;
};

const findSelectedCategoryItemsFromReport = (
  standardReportId: number,
  categories: FindReportSideNavItem[],
): {
  selectedCategory: FindReportSideNavItem;
  selectedSubCategory: FindReportSideNavItem;
} => {
  for (const cat of categories) {
    // Skip the Searchable Category, its used only for searching
    if (cat.name === SideNavCategoryTypeName.Searchable) {
      continue;
    }
    const subCat = searchSubCategory(
      cat.items as FindReportSideNavItem[],
      standardReportId,
    );
    if (subCat) {
      return {
        selectedCategory: cat,
        selectedSubCategory: subCat,
      };
    }
  }

  return {
    selectedCategory: null,
    selectedSubCategory: null,
  };
};

export { findSelectedCategoryItemsFromReport };
